import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/lib/api/orpc';
import { QUERY_PRESETS } from '@/lib/query';

/** ID Overview Row 1 — 全ID数 + 個人ID内訳 + グループID件数（集約 count エンドポイント） */
export const useIdOverviewCount = () => {
  return useQuery({
    ...orpc.idOverview.count.queryOptions(),
    ...QUERY_PRESETS.list(),
    // エラー時はグローバルのエラーダイアログを出さず、各カードを 0 表示にフォールバックする
    meta: {
      disableGlobalErrorHandling: true
    }
  });
};